/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { Breadcrumb, Modal, Loader } from 'semantic-ui-react';
import { observer, inject } from 'mobx-react';
import { v4 as uuidv4 } from 'uuid';
import cx from 'classnames';
import Update from 'immutability-helper';
import { Scrollbars } from 'react-custom-scrollbars-2';
import closeBtn from '../../images/components/new_scan/close-btn.svg';
import foldIcon from '../../images/common/fold-icon.svg';
import api from '../../api';
import SecurityDetailModal from './SecurityDetailModal';
//import Loader from '../Loader/Loader';
import './PatchVerisonModal.css';

class PatchVerisonModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenMPV: props.isOpenMPV,
      isOpenMSD: false,
      cveCode: props.cveCode,
      componentList: props.componentList,
      cveData: {},
      selectedCode: '',
      selectedName: null,
      selectedVersion: null,
      securityList: [],
      activeIndex: [],
      isLoadingContent: false,
      isLoadingTree: false,
      activeLoadingIndex: null,
      //compareList: [],
    };
    this.toggleRow = this.toggleRow.bind(this);
    this.handleSecurityDetailModal = this.handleSecurityDetailModal.bind(this);
    this.handleMSDClose = this.handleMSDClose.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {}

  componentDidUpdate(prevProps) {
    const { isOpenMPV, cveCode, componentList } = this.props;
    if (prevProps.isOpenMPV !== isOpenMPV) {
      this.setState({
        isOpenMPV,
        componentList,
        cveCode,
      });
      if (!isOpenMPV) {
        this.setState({
          isOpenMSD: false,
          isOpenMPV,
          activeIndex: [],
          cveData: {},
          selectedCode: '',
          securityList: [],
          selectedName: null,
          selectedVersion: null,
          isLoadingContent: false,
          isLoadingTree: false,
          activeLoadingIndex: null,
        });
      }
    }
  }

  handleSecurityDetailModal(e, value) {
    const data = {
      security_name: value,
    };
    api
      .getComponentSecurityDetail(data)
      .then((response) => {
        this.setState({
          cveData: response.response,
          selectedCode: value,
          isOpenMSD: true,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  handleMSDClose() {
    this.setState({
      isOpenMSD: false,
    });
  }

  getComponentPatchVersions = (componentName, updateIndex) => {
    const { cveCode, componentList } = this.state;
    const body = {
      component_name: componentName,
      code: cveCode,
    };

    this.setState({
      isLoadingTree: true,
      activeLoadingIndex: componentName,
    }, () => {
      api
        .getComponentPatchVersions(body)
        .then((response) => {
          const data = response.response;
          if (data.length !== 0) {
            const filteredArr = data.reduce((acc, current) => {
              const x = acc.find((item) => {
                return item.simple_version === current.simple_version;
              });
              if (!x) {
                const newCurr = {
                  simple_version: current.simple_version,
                  db_version: [current.db_version],
                };
                return acc.concat([newCurr]);
              }

              const currData = x.db_version.filter((d) => {
                return d === current.db_version;
              });

              if (!currData.length) {
                x.db_version.push(current.db_version);
                const newCurr = {
                  simple_version: current.simple_version,
                  db_version: x.db_version,
                };

                if (!newCurr) {
                  console.log(acc);
                }
                return acc;
              }
              return acc;
            }, []);

            this.setState({
              componentList: Update(componentList, {
                [updateIndex]: {
                  children: {
                    $set: filteredArr,
                  },
                },
              }),
              isLoadingTree: false,
              activeLoadingIndex: null,
            });
          } else {
            //const newState = activeIndex.filter((item) => {
            //              return item !== componentName;
            //});
            this.setState({
              isLoadingTree: false,
              activeLoadingIndex: null,
              //activeIndex: newState,
            });
          }
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            isLoadingTree: false,
            activeLoadingIndex: null,
          });
        });
    });
  };

  getComponentPatchVersionRisk = (name, versionArray) => {
    if (versionArray.length === 1) {
      const body = {
        component_name: name,
        component_version: versionArray[0],
      };

      this.setState({
        isLoadingContent: true,
      }, () => {
        api
          .getComponentPatchVersionRisk(body)
          .then((response) => {
            const data = response.response;
            this.setState({
              securityList: data.securities,
              isLoadingContent: false,
            });
          })
          .catch((err) => {
            console.log(err);
            this.setState({
              isLoadingContent: false,
            });
          });
      });
    }

    if (versionArray.length > 1) {
      this.checkVersionRisk(name, versionArray);
    }

    if (versionArray.length === 0) {
      return this.setState({
        securityList: [],
        isLoadingContent: false,
      });
    }
  };

  getDetailInfo = (name, versionObj) => {
    const { selectedVersion } = this.state;

    if (selectedVersion === versionObj.simple_version) {
      this.setState({
        securityList: [],
        selectedName: null,
        selectedVersion: null,
      });
    } else {
      this.setState({
        selectedName: name,
        selectedVersion: versionObj.simple_version,
      }, () => {
        this.getComponentPatchVersionRisk(name, versionObj.db_version);
      });
    }
  };

  getScrollIntoView = (type, name, version) => {
    const { componentList, activeIndex } = this.state;
    const nameIndex = componentList.findIndex((item) => {
      return item.component_name === name;
    });

    if (type === 'name') {
      this.nameRef.children[nameIndex].scrollIntoView();
    } else if (type === 'version') {
      const versionIndex = componentList[nameIndex].children.findIndex((item) => {
        return item.simple_version === version;
      });
      if (activeIndex.indexOf(name) < 0) {
        this.setState({
          activeIndex: [...activeIndex, name],
        }, () => {
          this.versionRef.children[versionIndex].scrollIntoView({ block: 'center' });
        });
      } else {
        this.versionRef.children[versionIndex].scrollIntoView({ block: 'center' });
      }
    }
  };

  loadVersionLisk = async (name, version) => {
    const body = {
      component_name: name,
      component_version: version,
    };

    const data = await api.getComponentPatchVersionRisk(body);
    return data;
  };

  toggleRow = (obj) => {
    let newState;
    const { activeIndex, componentList } = this.state;
    const componentName = obj.component_name;
    const updateIndex = componentList.findIndex((item) => {
      return item.component_name === componentName;
    });

    if (activeIndex.indexOf(componentName) > -1) {
      newState = activeIndex.filter((i) => {
        return i !== componentName;
      });
      return this.setState({
        activeIndex: newState,
      });
    }

    if (componentList[updateIndex].children.length === 0) {
      this.getComponentPatchVersions(componentName, updateIndex);
    }

    newState = [...activeIndex, componentName];
    return this.setState({
      activeIndex: newState,
    });
  };

  async checkVersionRisk(name, versionArray) {
    const newData = [];
    const countArray = [];

    this.setState({
      isLoadingContent: true,
    });

    versionArray.forEach(async (item, index) => {
      const data = await this.loadVersionLisk(name, item, index, versionArray);
      const res = data.response.security_count;

      const newObj = {
        version: versionArray[index],
        securities: data.response.securities,
      };
      newData.push(newObj);
      countArray.push(res.total);

      if (index + 1 === versionArray.length) {
        const allEqual = countArray.findIndex((a) => {
          return a === countArray[0];
        });
        if (allEqual) {
          return this.setState({
            securityList: newData[0].securities,
            isLoadingContent: false,
          });
        }

        const maxValue = Math.max(...countArray);
        const maxIndex = countArray.findIndex((b) => {
          return b === maxValue;
        });

        return this.setState({
          securityList: newData[maxIndex].securities,
          isLoadingContent: false,
        });
      }
    });
  }

  closeModal() {
    this.props.closeModal();
  }

  renderSecurityList() {
    const { securityList } = this.state;
    const { translate } = this.props;

    if (securityList.length === 0) {
      return null;
    }

    const totalCount = securityList.critical.length + securityList.high.length + securityList.medium.length + securityList.low.length;

    if (totalCount === 0) {
      return (
        <table className="table table_type_3">
          <colgroup>
            <col style={{ width: '40%' }} />
            <col style={{ width: '25%' }} />
            <col />
          </colgroup>
          <tbody>
            <tr>
              <th>{translate('chart.title.severity')}</th>
              <th>{translate('chart.title.score')}</th>
              <th>
                {translate('chart.title.cve_code')}
                (0)
              </th>
            </tr>
            <tr>
              <td colSpan="3" style={{ textAlign: 'center', fontWeight: '600' }}>
                {translate('modal.message.no_vuln_found')}
              </td>
            </tr>
          </tbody>
        </table>
      );
    }

    return (
      <table className="table table_type_3">
        <colgroup>
          <col style={{ width: '40%' }} />
          <col style={{ width: '25%' }} />
          <col />
        </colgroup>
        <tbody>
          <tr>
            <th>{translate('chart.title.severity')}</th>
            <th>{translate('chart.title.score')}</th>
            <th>
              {translate('chart.title.cve_code')}
              (
              {totalCount}
              )
            </th>
          </tr>
          {
            securityList.critical.length !== 0
            && securityList.critical.map((item, i) => {
              if (i === 0) {
                return (
                  <tr key={uuidv4()}>
                    <td rowSpan={securityList.critical.length} className="vat">
                      Critical
                    </td>
                    <td>
                      {item.score}
                    </td>
                    <td
                      //className="tac"
                      className=""
                    >
                      <div className="block bullet bullet_red">
                        <span
                          className="name has_link"
                          onClick={(e) => {
                            return this.handleSecurityDetailModal(e, item.security_code);
                          }}
                          onKeyUp={(e) => {
                            return this.handleSecurityDetailModal(e, item.security_code);
                          }}
                        >
                          {item.security_code}
                        </span>
                      </div>
                    </td>
                  </tr>
                );
              }
              return (
                <tr key={uuidv4()}>
                  <td>
                    {item.score}
                  </td>
                  <td>
                    <div className="block bullet bullet_red">
                      <span
                        className="name has_link"
                        onClick={(e) => {
                          return this.handleSecurityDetailModal(e, item.security_code);
                        }}
                        onKeyUp={(e) => {
                          return this.handleSecurityDetailModal(e, item.security_code);
                        }}
                      >
                        {item.security_code}
                      </span>
                    </div>
                  </td>
                </tr>
              );
            })
          }
          {
            securityList.high.length !== 0
            && securityList.high.map((item, j) => {
              if (j === 0) {
                return (
                  <tr key={uuidv4()}>
                    <td rowSpan={securityList.high.length} className="vat">
                      High
                    </td>
                    <td>
                      {item.score}
                    </td>
                    <td>
                      <div className="block bullet bullet_orange">
                        <span
                          className="name has_link"
                          onClick={(e) => {
                            return this.handleSecurityDetailModal(e, item.security_code);
                          }}
                          onKeyUp={(e) => {
                            return this.handleSecurityDetailModal(e, item.security_code);
                          }}
                        >
                          {item.security_code}
                        </span>
                      </div>
                    </td>
                  </tr>
                );
              }
              return (
                <tr key={uuidv4()}>
                  <td>
                    {item.score}
                  </td>
                  <td>
                    <div className="block bullet bullet_orange">
                      <span
                        className="name has_link"
                        onClick={(e) => {
                          return this.handleSecurityDetailModal(e, item.security_code);
                        }}
                        onKeyUp={(e) => {
                          return this.handleSecurityDetailModal(e, item.security_code);
                        }}
                      >
                        {item.security_code}
                      </span>
                    </div>
                  </td>
                </tr>
              );
            })
          }
          {
            securityList.medium.length !== 0
            && securityList.medium.map((item, k) => {
              if (k === 0) {
                return (
                  <tr key={uuidv4()}>
                    <td rowSpan={securityList.medium.length} className="vat">
                      Medium
                    </td>
                    <td>
                      {item.score}
                    </td>
                    <td>
                      <div className="block bullet bullet_cheese">
                        <span
                          className="name has_link"
                          onClick={(e) => {
                            return this.handleSecurityDetailModal(e, item.security_code);
                          }}
                          onKeyUp={(e) => {
                            return this.handleSecurityDetailModal(e, item.security_code);
                          }}
                        >
                          {item.security_code}
                        </span>
                      </div>
                    </td>
                  </tr>
                );
              }
              return (
                <tr key={uuidv4()}>
                  <td>
                    {item.score}
                  </td>
                  <td>
                    <div className="block bullet bullet_cheese">
                      <span
                        className="name has_link"
                        onClick={(e) => {
                          return this.handleSecurityDetailModal(e, item.security_code);
                        }}
                        onKeyUp={(e) => {
                          return this.handleSecurityDetailModal(e, item.security_code);
                        }}
                      >
                        {item.security_code}
                      </span>
                    </div>
                  </td>
                </tr>
              );
            })
          }
          {
            securityList.low.length !== 0
            && securityList.low.map((item, l) => {
              if (l === 0) {
                return (
                  <tr key={uuidv4()}>
                    <td rowSpan={securityList.low.length} className="vat">
                      Low
                    </td>
                    <td>
                      {item.score}
                    </td>
                    <td>
                      <div className="block bullet bullet_yellow">
                        <span
                          className="name has_link"
                          onClick={(e) => {
                            return this.handleSecurityDetailModal(e, item.security_code);
                          }}
                          onKeyUp={(e) => {
                            return this.handleSecurityDetailModal(e, item.security_code);
                          }}
                        >
                          {item.security_code}
                        </span>
                      </div>
                    </td>
                  </tr>
                );
              }
              return (
                <tr key={uuidv4()}>
                  <td>
                    {item.score}
                  </td>
                  <td>
                    <div className="block bullet bullet_yellow">
                      <span
                        className="name has_link"
                        onClick={(e) => {
                          return this.handleSecurityDetailModal(e, item.security_code);
                        }}
                        onKeyUp={(e) => {
                          return this.handleSecurityDetailModal(e, item.security_code);
                        }}
                      >
                        {item.security_code}
                      </span>
                    </div>
                  </td>
                </tr>
              );
            })
          }
        </tbody>
      </table>
    );

  }

  render() {
    const {
      isOpenMPV,
      isOpenMSD,
      cveCode,
      componentList,
      activeIndex,
      cveData,
      selectedCode,
      selectedName,
      selectedVersion,
      isLoadingContent,
      isLoadingTree,
      activeLoadingIndex,
    } = this.state;
    const { translate } = this.props;

    return (
      <Modal
        open={isOpenMPV}
        onClose={this.closeModal}
      >
        <div className="setting_popup default_popup has_setting_popup_tab match_detail patch_version">
          <div className="setting_popup_header">
            <h2 className="popup_name">
              {translate('modal.message.patch_version_of')}
              {' '}
              {cveCode}
            </h2>
            <a className="popup_close_button" onClick={this.closeModal} onKeyUp={this.closeModal}>
              <img src={closeBtn} alt="" />
            </a>
          </div>
          <div className="setting_popup_contnets">
            <div className="setting_popup_content_wrap">
              <div className="setting_popup_content">
                <table className="table">
                  <colgroup>
                    <col style={{ width: '205px' }} />
                    <col style={{ width: '' }} />
                  </colgroup>
                  <tbody>
                    <tr>
                      <td>
                        <div className="table_wrap table_type_3" style={{ height: '523px' }}>
                          <div className="title_wrap">
                            <div className="security_title">{translate('contents_header.link_header.components')}</div>
                          </div>
                          <div className="" style={{ height: '479px' }}>
                            <Scrollbars
                              style={{
                                position: 'relative',
                                overflow: 'hidden',
                                height: '100%',
                              }}
                              renderTrackHorizontal={() => {
                                return <div />;
                              }}
                              renderThumbHorizontal={() => {
                                return <div />;
                              }}
                            >
                              <ul
                                className="depth_ul"
                                ref={(ref) => {
                                  this.nameRef = ref;
                                }}
                              >
                                {
                                  componentList.map((item, index) => {
                                    return (
                                      <li
                                        className={cx('depth_1', {
                                          expand: activeIndex.indexOf(item.component_name) > -1,
                                        })}
                                        key={uuidv4()}
                                        data-id={index}
                                      >
                                        <a
                                          style={{ cursor: 'pointer' }}
                                          className="component_name"
                                          onClick={() => {
                                            return this.toggleRow(item);
                                          }}
                                          onKeyUp={() => {
                                            return this.toggleRow(item);
                                          }}
                                        >
                                          {
                                            activeIndex.indexOf(item.component_name) > -1 ? (
                                              `${item.component_name} (${item.children.length})`
                                            ) : (
                                              item.component_name
                                            )
                                          }
                                          <span className="fold_icon">
                                            <img src={foldIcon} alt="" />
                                          </span>
                                        </a>
                                        {
                                          isLoadingTree && activeLoadingIndex === item.component_name ? (
                                            <Loader size="small" active={isLoadingTree} inline="centered" />
                                          ) : (
                                            <ul
                                              className="match_detail_ul"
                                              ref={(ref) => {
                                                this.versionRef = ref;
                                              }}
                                            >
                                              {
                                                item.children.length !== 0 ? (
                                                  item.children.map((nest, i) => {
                                                    return (
                                                      <li
                                                        key={uuidv4()}
                                                        className={cx('', {
                                                          active: selectedVersion === nest.simple_version,
                                                        })}
                                                        data-id={i}

                                                      >
                                                        <a
                                                          onClick={() => {
                                                            return this.getDetailInfo(item.component_name, nest);
                                                          }}
                                                          onKeyUp={() => {
                                                            return this.getDetailInfo(item.component_name, nest);
                                                          }}
                                                          style={{ border: 'none', fontSize: '13px', padding: '10px 0' }}
                                                        >
                                                          <span
                                                            className="simple_version"
                                                          >
                                                            {nest.simple_version}
                                                          </span>
                                                        </a>

                                                      </li>
                                                    );
                                                  })
                                                ) : null
                                              }
                                            </ul>
                                          )
                                        }
                                      </li>
                                    );
                                  })
                                }
                              </ul>
                            </Scrollbars>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div className="table_wrap table_type_3" style={{ height: '523px' }}>
                          <div className="title_wrap">
                            <div className="security_title">{translate('modal.title.security_info')}</div>
                            {
                              selectedVersion ? (
                                <Breadcrumb className="security_path">
                                  <Breadcrumb.Section
                                    active={selectedName !== null}
                                    link
                                    onClick={() => {
                                      return this.getScrollIntoView('name', selectedName);
                                    }}
                                  >
                                    {selectedName}

                                  </Breadcrumb.Section>
                                  <Breadcrumb.Divider icon="right chevron" />
                                  <Breadcrumb.Section
                                    active={selectedVersion !== null}
                                    link
                                    onClick={() => {
                                      return this.getScrollIntoView('version', selectedName, selectedVersion);
                                    }}
                                  >
                                    {selectedVersion}

                                  </Breadcrumb.Section>
                                </Breadcrumb>
                              ) : null
                            }
                          </div>
                          <div className="security_list" style={{ height: '479px' }}>
                            {
                              isLoadingContent ? (
                                <Loader size="medium" active={isLoadingContent} inline="centered" />
                              ) : (
                                <Scrollbars
                                  style={{
                                    position: 'relative',
                                    overflow: 'hidden',
                                    height: '100%',
                                  }}
                                  renderTrackHorizontal={() => {
                                    return <div />;
                                  }}
                                  renderThumbHorizontal={() => {
                                    return <div />;
                                  }}
                                >
                                  {this.renderSecurityList()}
                                </Scrollbars>
                              )
                            }
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <SecurityDetailModal
          isOpenMSD={isOpenMSD}
          closeModal={this.handleMSDClose}
          cveData={cveData}
          selectedCode={selectedCode}
          translate={translate}
        />
      </Modal>
    );
  }
}

export default inject('state')(observer(PatchVerisonModal));
